import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable } from 'knockout';
import CommunityNavigationWidgetItemModel from '../item';
import CommunityNavigationWidgetVM from '../navigation';
import './navigation.html';

components.registerLocal('community-navigation-desktop-group', () => require('./group'));

@injectable()
export default class CommunityDesktopNavigationWidgetVM {
    items: Subscribable<Array<CommunityNavigationWidgetItemModel>>

    showEmptyMessage: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) root: CommunityNavigationWidgetVM,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        this.items = root.links;
        this.showEmptyMessage = ko.pureComputed(() => root.isDemo() && this.items().length == 0);

        ko.applyBindingsToNode(info.element, {
            'css': {
                'community__desktop-navigation': true
            }
        });
    }
}